<template>
	<tr>
		<td class="text-truncate">
			{{ sitemapPathname }}
		</td>
		<td class="text-center">
			{{ result.matched }}
		</td>
		<td class="text-center">
			{{ result.name }}
		</td>
		<td class="text-truncate">
			<a
				class="link-secondary"
				:href="result.url"
				target="_blank"
				rel="noopener noreferrer"
				>{{ result.url }}</a
			>
		</td>
		<td class="matches-cell text-truncate">
			<ul
				v-if="result.matches"
				class="list-group list-group-flush matches-container"
			>
				<li
					v-for="(match, index) in result.matches"
					class="list-group-item"
					:key="index"
				>
					{{ match }}
				</li>
			</ul>
		</td>
	</tr>
</template>

<script lang="ts">
import { useUUID } from "@/hooks/useUUID";
import { RegexResult } from "@/services/regexWatcherService";
import { getPathname } from "@/utils";
import { computed, defineComponent, toRefs } from "vue";

export default defineComponent({
	props: {
		result: {
			type: Object as () => RegexResult,
			required: true,
		},
	},
	setup(props) {
		const { result } = toRefs(props);

		const sitemapPathname = computed(() =>
			getPathname(result.value.sitemap)
		);

		const uuid = useUUID();
		const matchesElementId = `matches-collapse-${uuid.value}`;

		return {
			sitemapPathname,
			matchesElementId,
		};
	},
});
</script>

<style scoped>
.matches-cell {
	padding: 0;
	max-width: 0;
}

.matches-container {
	max-height: 10rem;
	overflow-y: auto;
	overflow-x: hidden;
}
</style>
